import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ContactStateRequest, ContactStateResponse, PageResponse } from '../models/contact-state.model';

@Injectable({
  providedIn: 'root'
})
export class ContactStateApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-states?businessId=&page=&size=
  getStates(businessId: number, page = 0, size = 100): Observable<ContactStateResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<ContactStateResponse>>(`${this.apiUrl}/contact-states`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/contact-states/{id}?businessId=
  getStateById(id: number, businessId: number): Observable<ContactStateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactStateResponse>(`${this.apiUrl}/contact-states/${id}`, { params });
  }

  // POST /api/contact-states
  createState(state: ContactStateRequest): Observable<ContactStateResponse> {
    return this.http.post<ContactStateResponse>(`${this.apiUrl}/contact-states`, state);
  }

  // PUT /api/contact-states/{id}
  updateState(id: number, state: ContactStateRequest): Observable<ContactStateResponse> {
    return this.http.put<ContactStateResponse>(`${this.apiUrl}/contact-states/${id}`, state);
  }

  // DELETE /api/contact-states/{id}?businessId=
  deleteState(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-states/${id}`, { params });
  }
}
